import React, { useMemo, useEffect, useState } from "react";
import ReactQuill from "react-quill";
import EditorToolbar, { modules, formats } from "./EditorToolbar";
import "react-quill/dist/quill.snow.css";
import "./Editor.css";

import {
  storage,
  ref,
  uploadBytes,
  uploadBytesResumable,
  getDownloadURL,
  deleteObject,
  addDoc,
  collection,
  db,
  serverTimestamp,
  updateDoc,
  doc,
  setDoc,
  getDoc,
} from "../../firebase";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import { useParams } from "react-router-dom";
import { HashLink } from "react-router-hash-link";

export const Editor = () => {
  const [board, setBoard] = useState([]);
  const [state, setState] = React.useState({ value: "" });
  const [title, setTitle] = React.useState("");
  const [done, setDone] = React.useState(false);

  let { id } = useParams();

  useEffect(() => {
    setBoard([]);
    window.scrollTo(0, 0);
    getBoards();
  }, []);

  const getBoards = async () => {
    const docRef = doc(db, "board", id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      console.log("Document data:", docSnap.data());
      setBoard(docSnap.data());
      setTitle(docSnap.data().title);
      setState({ value: docSnap.data().message });
      setDoc(docRef, { viewed: docSnap.data().viewed + 1 }, { merge: true });
    } else {
      // doc.data() will be undefined in this case
      console.log("No such document!");
    }
  };

  const reset = () => {
    setDone(false);
    setTitle("");
    setState({ value: "" });
  };

  const handleChange = (value) => {
    setState({ value });
  };

  const submit = async () => {
    await setDoc(doc(db, "board", id), {
      created: serverTimestamp(),
      message: state.value,
      viewed: board.viewed,
      title: title,
    });

    // const docRef = await setDoc(collection(db, "board", id), {
    //   created: serverTimestamp(),
    //   message: state.value,
    //   viewed: board.viewed,
    //   title: title,
    // });
    // console.log("Document written with ID: ", docRef.id);
    setDone(true);
    window.scrollTo(0, 0);
  };

  // Undo and redo functions for Custom Toolbar
  function undoChange() {
    this.quill.history.undo();
  }
  function redoChange() {
    this.quill.history.redo();
  }

  const modules = useMemo(() => {
    return {
      toolbar: {
        container: "#toolbar",
        handlers: {
          undo: undoChange,
          redo: redoChange,
        },
      },
      history: {
        delay: 500,
        maxStack: 100,
        userOnly: true,
      },
      imageUpload: {
        url: "", // server url. If the url is empty then the base64 returns
        method: "POST", // change query method, default 'POST'
        name: "image", // custom form name
        withCredentials: false, // withCredentials
        headers: {}, // add custom headers, example { token: 'your-token'}
        csrf: { token: "token", hash: "" }, // add custom CSRF
        customUploader: async (file) => {
          const random = Math.floor(Math.random() * 100000000000000);
          const storageRef = ref(storage, "board/" + random + file.name);
          const uploadTask = uploadBytesResumable(storageRef, file);
          console.log("upload", file);
          console.log("uploadTask", uploadTask);

          await uploadTask.on(
            "state_changed",
            (snapshot) => {
              // Observe state change events such as progress, pause, and resume
              // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
              const progress =
                (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
              console.log("Upload is " + progress + "% done");
              switch (snapshot.state) {
                case "paused":
                  console.log("Upload is paused");
                  break;
                case "running":
                  console.log("Upload is running");
                  break;
              }
            },
            (error) => {
              // Handle unsuccessful uploads
            },
            () => {
              // Handle successful uploads on complete
              // For instance, get the download URL: https://firebasestorage.googleapis.com/...
              getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
                // if (
                //   imageUrl !== undefined &&
                //   imageUrl2 !== undefined &&
                //   imageUrl3 !== undefined
                // ) {
                //   alert("Maximum number of photo is 3.");
                // }

                console.log("File available at", downloadURL);
                if (state.value) {
                  setState({
                    value: state.value + `<img src="${downloadURL}" />` + "",
                  });
                } else {
                  setState({
                    value: `<img src="${downloadURL}" />` + "",
                  });
                }
              });
            }
          );
        }, // add custom uploader
        // personalize successful callback and call next function to insert new url to the editor
        callbackOK: (serverResponse, next) => {
          next(serverResponse);
        },
        // personalize failed callback
        callbackKO: (serverError) => {
          alert(serverError);
        },
        // optional
        // add callback when a image have been chosen
        checkBeforeSend: (file, next) => {
          console.log(file);
          next(file); // go back to component and send to the server
        },
      },
    };
  }, []);

  // Modules object for setting up the Quill editor

  return (
    <>
      {done ? (
        <Box>
          <Box sx={{ color: "#153a5a" }}>
            제목: "{title}"의 공지사항이 저장 되었습니다.
          </Box>
          <HashLink to="/admin/board">
            <button
              className="custom_btn"
              style={{
                width: "200px",
                marginTop: "20px",
                marginBottom: "30px",
              }}
            >
              모든 공지사항 보러가기
            </button>
          </HashLink>
        </Box>
      ) : null}
      <div className="text-editor">
        <Box sx={{ mb: 2, mt: 3 }}>
          <TextField
            id="outlined-basic"
            label="공지사항 제목"
            variant="outlined"
            sx={{ width: 1 }}
            onChange={(e) => setTitle(e.target.value)}
            value={title}
          />
        </Box>
        <EditorToolbar />
        <ReactQuill
          theme="snow"
          value={state.value}
          onChange={handleChange}
          placeholder={"내용을 적어주세요"}
          modules={modules}
          formats={formats}
          defaultValue={""}
        />

        <button
          onClick={submit}
          className="custom_btn"
          style={{ width: "200px", marginTop: "20px" }}
        >
          제출하기
        </button>
      </div>
    </>
  );
};

export default Editor;
